import { useMutation } from '@occc-app/dataAccessLayer/utils';
import {
  UpdateTriggeredMessageMutationOptions,
  useUpdateTriggeredMessageMutation,
} from '@occc/graphql';

export const useUpdateTriggeredMessage = (options?: UpdateTriggeredMessageMutationOptions) => {
  return useMutation(useUpdateTriggeredMessageMutation, options);
};
